import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'antd';

import { BANKS_COMMON } from 'containers/BanksPage/constants';
import Modal from 'components/Common/Modal';
import Input from 'components/Common/Input';

const { Item } = Form;

const BanksModal = ({
  isVisible,
  currentBank,
  toggleModal,
  onUpdateBank,
  onCreateBank,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (currentBank) {
      form.setFieldsValue(currentBank);
    }

    return () => form.resetFields();
  }, [currentBank]);

  const okText = currentBank ? 'Update' : 'Add';

  const titleText = currentBank ? 'Update bank' : 'Add bank';

  const onSubmit = () => {
    const name = form.getFieldValue(BANKS_COMMON.name);

    if (currentBank) {
      onUpdateBank({ name, id: currentBank.id });
      form.resetFields();

      return;
    }

    onCreateBank(name);
    form.resetFields();
  };

  return (
    <Modal
      open={isVisible}
      title={titleText}
      okText={okText}
      onCancel={toggleModal(false)}
      onOk={form.submit}
    >
      <Form form={form} onFinish={onSubmit}>
        <Item
          name={BANKS_COMMON.name}
          label={BANKS_COMMON.name_title}
          rules={[
            {
              required: true,
              message: 'Please enter bank name',
            },
          ]}
        >
          <Input />
        </Item>
      </Form>
    </Modal>
  );
};

BanksModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  currentBank: PropTypes.object,
  toggleModal: PropTypes.func.isRequired,
  onUpdateBank: PropTypes.func.isRequired,
  onCreateBank: PropTypes.func.isRequired,
};

export default BanksModal;
